import PubSub from 'pubsub-js';
import { gsap, Expo } from 'gsap';

import { update } from './circlePosition';

const $html = $('html');
const $backgroundCircle = $('.background-circle');
const $circleGroup = $('.background-circleGroup');

const drawLine = () => {
    const duration = $html.hasClass('-opening') ? 5 : 4;
    $backgroundCircle.each((index, element) => {
        const $svgPath = $('svg path', element);
        const svg = $svgPath.get(0);
        const svgLength = svg.getTotalLength();
        $svgPath.css('stroke-dasharray', svgLength);
        $svgPath.css('stroke-dashoffset', svgLength);
    
        gsap.fromTo(
            svg, 
            { 'stroke-dashoffset': svgLength },
            { 'stroke-dashoffset': '0', duration, stagger: 0.1, ease: Expo.easeInOut },
        )
    });
}

PubSub.subscribe('init', () => {
    drawLine();
    $circleGroup.removeClass('-hide');
});

PubSub.subscribe('top.updateScene', (_msg, data) => {
    $circleGroup.attr('data-scene', data);
    drawLine();
    PubSub.publish('top.updateBackgroundCircle');
});

PubSub.subscribe('top.updateBackgroundCircle', () => {
    const scene = Number($circleGroup.attr('data-scene'));
    update(scene);
});